/** Formats a raw digit string into (XXX) XXX-XXXX */
export function maskPhone(value: string): string {
	const digits = value.replace(/\D/g, '').slice(0, 10);
	if (digits.length <= 3) return digits.length ? `(${digits}` : '';
	if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
	return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

/** Formats a raw digit/slash string into MM/DD/YYYY */
export function maskDate(value: string): string {
	const digits = value.replace(/\D/g, '').slice(0, 8);
	if (digits.length <= 2) return digits;
	if (digits.length <= 4) return `${digits.slice(0, 2)}/${digits.slice(2)}`;
	return `${digits.slice(0, 2)}/${digits.slice(2, 4)}/${digits.slice(4)}`;
}

/**
 * Converts a bridge-supplied date string to MM/DD/YYYY.
 * Accepts already-formatted MM/DD/YYYY (pass-through) and ISO YYYY-MM-DD.
 * Returns null for unrecognised formats.
 */
export function normalizeDateForBridge(value: string): string | null {
	if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) return value;
	const iso = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
	if (iso) return `${iso[2]}/${iso[3]}/${iso[1]}`;
	// Value is omitted deliberately — it is a date of birth.
	console.warn('[PatientInfoWidget] Bridge supplied a date in an unrecognised format');
	return null;
}
